import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';
import { SPINNER_ANSWER_ICON } from '../../../constants/constants';
import BrokerConvenienceTestYellowDisclaimer from '../brokerConvenienceTestYellowDisclaimer/brokerConvenienceTestYellowDisclaimer'

const getRadialItemClass = (isSelected) => {
    const customClass = classNames('robo-radial-menu__petal', {
        ['robo-radial-menu__petal--selected']: isSelected,
    });

    return customClass;
}

const buildAnswer = (answer, onChange, questionId, sectionId) => {
    return answer.push(answer.get(0)).shift().map((ans, index) => {
        return (
            <li
                key={index}
                className={getRadialItemClass(ans.get('selected')==='S')}
                onClick={() => onChange(sectionId, questionId, ans.get('id'))}
                data-id={ans.get('id')}
            >
                <span className={`robo-radial-menu__petal__icon ${SPINNER_ANSWER_ICON[ans.get('id')]}`} />
                <span className="robo-radial-menu__petal__text">
                    {ans.get('description')}
                </span>
            </li>
        );
    })
}

const BrokerConvenienceTestSpinnerQuestion = ({answer, question, questionId, sectionId, onChange, disclaimer}) => {
        const disclaimerComponent = disclaimer ? (
            <BrokerConvenienceTestYellowDisclaimer>
                {disclaimer}
            </BrokerConvenienceTestYellowDisclaimer>
        ) : null;
        return (
            <div className="robo-radial-menu">
                <div className="robo-radial-menu__title">
                    {question}
                </div>
                {disclaimerComponent}
                <div className="robo-radial-menu__stem">
                    <ul className="robo-radial-menu__flower">
                        {buildAnswer(answer, onChange, questionId, sectionId)}
                    </ul>
                    <div className="robo-radial-menu__stigma" />
                </div>
            </div>
        );
};

BrokerConvenienceTestSpinnerQuestion.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.string,
    questionId: PropTypes.string,
    sectionId: PropTypes.string,
    onChange: PropTypes.func,
    disclaimer: PropTypes.string,
};

export default BrokerConvenienceTestSpinnerQuestion;
